// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__T9Ta5","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__13buc"};